import {
  Box,
  chakra,
  Divider,
  Flex,
  HStack,
  Icon,
  Link,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
  VStack,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import {Link as ReactLink, useNavigate } from "react-router-dom";

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={12}
      h={12}
      cursor={'pointer'}
      as={'a'}
      href={href}
      target={"_blank"}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function Footer() {
  const navigate = useNavigate()
  return (
    <Box
  bg="gray.100"
  _dark={{
    bg: "gray.600",
  }}
>
  <Stack
    direction={{
      base: "column",
      lg: "row",
    }}
    w="full"
    justify="space-between"
    p={10}
  >
    <HStack
      alignItems="start"
      flex={1}
      justify="space-around"
      fontSize={{
        base: "12px",
        md: "16px",
      }}
      color="gray.800"
      _dark={{
        color: "white",
      }}
      textAlign={{
        base: "center",
        md: "left",
      }}
    >

      <Flex justify="start" direction="column">
        <Text>Adresse</Text>
        <Link href='https://goo.gl/maps/6EpTKX1gLhkzFM4o6' target={"_blank"}><Text>Værftsgata 22, 1511 Moss</Text></Link>
        <Link href="mailto:kontakt@mossklatresenter.no" target={"_blank"}><Text>kontakt@mossklatresenter.no</Text></Link>
      </Flex>
      <Flex justify="start" direction="column">
        <Text>Åpningstider</Text>
        <Text>Mandag - Søndag: 06.00 - 00.00</Text>
      </Flex>
      
    </HStack>
    <HStack
      alignItems="start"
      flex={1}
      justify="space-around"
      fontSize={{
        base: "12px",
        md: "16px",
      }}
      color="gray.800"
      _dark={{
        color: "white",
      }}
      textAlign={{
        base: "center",
        md: "left",
      }}
    >
      <Flex justify="start" direction="column">
        <Link as={ReactLink} to={"/safety"} onClick={(event: any) => {event.preventDefault(); navigate('/safety')}}>Sikkerhet</Link>
        <Link as={ReactLink} to={"/safety"} onClick={(event: any) => {event.preventDefault(); navigate('/safety')}}>Regler på senteret</Link>
        <Link as={ReactLink} to={"/prices"} onClick={(event: any) => {event.preventDefault(); navigate('/prices')}}>Lån av utstyr</Link>
      </Flex>
      <Flex justify="start" direction="column">
        <Link as={ReactLink} to={"/return-policy"} onClick={(event: any) => {event.preventDefault(); navigate('/return-policy')}}>Angrerett</Link>
        <Link as={ReactLink} to={"/safety#terms"} onClick={(event: any) => {event.preventDefault(); navigate('/safety#terms')}}>Ansvarserklæring</Link>
      </Flex>
      
    </HStack>
  </Stack>
  <Divider
    w="95%"
    mx="auto"
    color="gray.600"
    _dark={{
      color: "#F9FAFB",
    }}
    h="3.5px"
  />
  <VStack py={3}>
    <Stack direction={'row'} spacing={6}>
        <SocialButton label={'Twitter'} href={'https://www.facebook.com/profile.php?id=100087851408744'}>
         
          <Icon as={FiFacebook} w={6} h={6} />
        </SocialButton>
        <SocialButton label={'Instagram'} href={'https://www.instagram.com/mossklatresenter/'}>
          <Icon as={FiInstagram} w={6} h={6} />
        </SocialButton>
      </Stack>
    <Text
      textAlign="center"
      fontSize="smaller"
      _dark={{
        color: "white",
      }}
    >
      © {new Date().getFullYear()} Moss Klatresenter - Organisasjonsnr: 930 034 258 
    </Text>
  </VStack>
</Box>
  );
}